import _toConsumableArray from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { __rest } from "tslib";
import React from 'react';
import { Field } from 'formik';
import { Size } from '@vtblife/uikit/legacy';
import { notEmpty as notEmptyValidator, pipe, mayBeEmptyString } from '@vtblife/validators';
import { getValidator } from './get-validator';
import { isValueNotPresentInOptions } from './is-value-not-present-in-options';
export var createFormikComponent = function createFormikComponent(WrappedComponent, mapFunction) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    errorValidator = _ref.errorValidator,
    warningValidator = _ref.warningValidator,
    optionsValueKey = _ref.optionsValueKey;
  var Component = function Component(props) {
    return React.createElement(WrappedComponent, Object.assign({}, mapFunction(props)));
  };
  return function (props) {
    var required = props.required,
      template = props.template,
      _props$validators = props.validators,
      validators = _props$validators === void 0 ? [] : _props$validators,
      validateFromProps = props.validate,
      _props$warningValidat = props.warningValidators,
      warningValidators = _props$warningValidat === void 0 ? [] : _props$warningValidat,
      emptyOptionsAction = props.emptyOptionsAction,
      disabled = props.disabled,
      readOnly = props.readOnly,
      mayBeEmpty = props.mayBeEmpty,
      restProps = __rest(props, ["required", "template", "validators", "validate", "warningValidators", "emptyOptionsAction", "disabled", "readOnly", "mayBeEmpty"]);
    var fieldValidators = validators;
    var shouldValidate = !(disabled || readOnly);
    if (required) {
      var notEmpty = typeof required === 'string' ? notEmptyValidator({
        message: required
      }) : notEmptyValidator();
      fieldValidators.push(notEmpty);
      if (props.options && emptyOptionsAction === 'validate') {
        fieldValidators.push(function (value) {
          return isValueNotPresentInOptions(value, props.options, optionsValueKey) ? 'Обязательное поле' : undefined;
        });
      }
    }
    if (errorValidator) {
      fieldValidators.push(errorValidator);
    }
    if (template) {
      var validatorForTemplate = getValidator({
        template: template
      });
      if (validatorForTemplate) {
        fieldValidators.push(validatorForTemplate);
      }
    }
    if (warningValidator) {
      warningValidators.push(warningValidator);
    }
    var validate = shouldValidate && (validateFromProps || (!required && mayBeEmpty ? mayBeEmptyString.apply(void 0, _toConsumableArray(fieldValidators)) : pipe.apply(void 0, _toConsumableArray(fieldValidators))));
    var warningValidate = pipe.apply(void 0, _toConsumableArray(warningValidators));
    return React.createElement(Field, Object.assign({
      validate: validate,
      size: Size.Large,
      fullWidth: true,
      warningValidator: warningValidate,
      template: template,
      emptyOptionsAction: emptyOptionsAction,
      required: required,
      disabled: disabled,
      readOnly: readOnly
    }, restProps, {
      component: Component
    }));
  };
};